import Link from 'next/link';
import Cap from '@/frontend/components/qecomps/Cap';
import Router from 'next/router'
import { SSRGlobal } from '../qecomps/Context';

export default (reroute, pathtranslate) => {
    let z = SSRGlobal()
    let paths:any = z.user.path.replace("#", "").split('/')
    paths.splice(0, 1)
    if (paths[paths.length - 1].includes("?")) {
        paths[paths.length - 1] = paths[paths.length - 1].split("?")[0]
    }

    paths = paths.map((n, i) => {
        let temparr = paths;
        let nx = n.split("?")
        if (nx.length > 0) {
            n = nx[0]
        }
        
        let route = reroute(paths, n);
        let lastchar = (i == paths.length - 1) && (route != false) ?"":">";
        // console.log("HERE:", route)

        let href = "";
        if (route == true) {
            href = "/" + temparr.slice(0, i + 1).join("/")
        }
        else if (typeof route == "string") {
            href = (z.root + route)
        }
        else if(typeof route == "function")
        {
            route();
        }
        else if (route == false)
        {
            return null
        }

        return <Link key={"paths_" + i} href={href}><a-s 
        // onClickx={() => 
        // {
        //     if (route == true) {
        //         Router.push("/" + temparr.slice(0, i + 1).join("/"))
        //     }
        //     else if (typeof route == "string") {
        //         Router.push(z.root + route)
        //     }
        //     else if(typeof route == "function")
        //     {
        //         route();
        //     }
        // }}
        
        >{Cap(z.lang.path?.[n] || pathtranslate?.[n] || n)}</a-s>{lastchar}</Link>
    })
    return paths;
}